import React from 'react';
import "./index.scss";

const RadioButton = ({ item, checked, onChange, disabled}: {item: {id: string; title: string}, checked: boolean, disabled?: boolean, onChange: (data: any) => void }) => {
  return (
    <div className='radio-button'>
      <div className="flex items-center">
        <input
          id={item.id}
          name="position"
          type="radio"
          className="focus:ring-transparent"
          checked={checked}
          onChange={(value) => !disabled ? onChange(value) : {}}
          disabled={disabled}
        />
        <label htmlFor={item.id} className="ml-1.5 block text-sm font-medium leading-6">
          {item.title}
        </label>
      </div>
    </div>
  )
};

export default RadioButton;